const settings = [
  {
    path: '/settings/profile',
    name: 'profile-settings',
    component: () => import('@/pages/settings/Profile.vue'),
    meta: {
      title: 'Profile',
    },
  },
]

export default settings
